module.exports = __webpack_public_path__ + "img/5.6fcb3751.jpg";